import { createBlankSpy, createBlankSpyWithoutLaunchSettings } from 'domain/monitor'
import { useCreateMonitorMutation } from 'services/monitor'
import { CreateSpyWithParams } from './types'

function createSpyBaseStructure(params: CreateSpyWithParams): any {
    if (params.launchSettings === undefined){
        return createBlankSpy()
    }

    return createBlankSpyWithoutLaunchSettings()
}

function createSpyFiltersStructure(params: CreateSpyWithParams){
    //const pets = []
    // if (params.filters.pets[0].indexOf('+') > -1){
    //     const petsNumber = parseInt(params.filters.pets[0])
    //     for (let i = 0; i < 20 - petsNumber; i++) {
    //         pets.push(petsNumber + i)
    //     }
    // } else {
    //     pets.push(params.filters.pets[0])
    // }
    const petsNumber = parseInt(params.filters.pets[0])
    const pets = petsNumber
    
    const beds = []
    if (params.filters.beds[0].toLowerCase().indexOf('any') > - 1){
        beds.push(0)
    } else if (params.filters.beds[0].indexOf('+') > -1){
        const bedsNumber = parseInt(params.filters.beds[0])
        for (let i = 0; i < 20 - bedsNumber; i++) {
            beds.push(bedsNumber + i)
        }
    } else {
        beds.push(params.filters.beds[0])
    }

    const bedrooms = []
    if (params.filters.bedrooms[0].toLowerCase().indexOf('any') > - 1){
        bedrooms.push(0)
    } else if (params.filters.bedrooms[0].indexOf('+') > -1){
        const bedroomsNumber = parseInt(params.filters.bedrooms[0])
        for (let i = 0; i < 20 - bedroomsNumber; i++) {
            bedrooms.push(bedroomsNumber + i)
        }
    } else {
        bedrooms.push(params.filters.bedrooms[0])
    } 

    return {
        pets: pets,
        beds: beds,
        bedrooms: bedrooms
    }
}

function createSpyLocationStructure(params: CreateSpyWithParams): any{
    return {
        locations: [params.location.id]   
    }
}

function createSpyLaunchStructure(params: CreateSpyWithParams): any{
    if (params.launchSettings !== undefined){
        if (params.launchSettings.mode === 'sliding'){
            const slidingPeriods = []
            const daysAhead = params.launchSettings.params.daysAhead

            for (let i = 0; i < daysAhead; i++) {
                slidingPeriods.push({
                    offset: i,
                    period: 1
                })
            }

            return {
                slidingPeriods
            }
        }

        if (params.launchSettings.mode === 'custom'){
            return {
              customPeriods: [
                    {
                        startDateTimeUtc: params.launchSettings.params.periods[0].startDate,
                        endDateTimeUtc: params.launchSettings.params.periods[0].endDate,
                    }  
                ]
            }
        }
    }

    return {
        slidingPeriods: [
            {
                offset: 0,
                period: 1
            },
                        {
                offset: 1,
                period: 1
            },
            {
                offset: 2,
                period: 1
            }
        ],
    }
}

export function useCreateSpyWithParams(): any {
    const [createMonitor] = useCreateMonitorMutation()

    const createSpyWithParams = async (params: CreateSpyWithParams) => {
        const spy: any = createSpyBaseStructure(params)
        const spyLocationStructure: any = createSpyLocationStructure(params)
        const spyLaunchStructure: any = createSpyLaunchStructure(params)
        const filtersStructure: any = createSpyFiltersStructure(params)

        const result = await createMonitor({
            monitor: {
                ...spy,
                ...spyLocationStructure,
                ...spyLaunchStructure,
                ...filtersStructure
            }
        })

        return result
    }

    return [ createSpyWithParams ]
}